require('./style.less');


var BaseRowView = require('../baseRowView/view');
    HitPreviewView = require('./textPreview/view'),
    ShapePropertiesViewFactory = require('../../../../notePropertyViews/shapeProperties/factory'),

require('jqDropDown');


module.exports = BaseRowView.extend({

    className: 'fr-hit-row-view',

    regions: _.extend( {}, BaseRowView.prototype.regions, { // TODO: we don't want hit hitCountRegion
        previewCellRegion:  '.fr-td-preview'
    }),
    
    /* init is showing as taking considerable time */
    initialize: function( options ) {

        BaseRowView.prototype.initialize.apply( this, arguments );

        this.zonePropertiesDropdown = null;

        var m = this.model;

        var hitShape = m.get('shape');

        this.listenTo( m , 'change:isMouseOverCanvasShape', this.toggleCanvasShapeHovered );

        // (for now piggy backing off the existing isSelected functionality of the shape )
        this.listenTo( hitShape.uiModel, 'change:isSelected', this.toggleShapeIsSelected );
        this.listenTo( hitShape.uiModel, 'change:isDirty', this.toggleShapeIsDirty );

        // This should be OK so only one can be open at a time; don't need to fire event for all.
        // We don't allow 2 dialogs of the same shape to be open at once.
        this.listenTo( hitShape, 'canvas:zoneDialogOpened', this.forceCloseDialog );

        // Cache once; should pass from parent for more perf gains ...
        // Could dynamically add event to toggleZonePropertiesDialog but this would hurt performance,
        // And isn't necessary for views without a dialog

        this.showZonePropertiesColumn = hitShape.getHasCustomizableProperties();
    },

    serializeData: function() {

        var baseCxt = BaseRowView.prototype.serializeData.apply( this, arguments );

        return _.extend( baseCxt, {
            isHitRow: true,
            showRevertBtn: this.model.get('shape').uiModel.get('isDirty'),
            showZonePropertiesColumn: this.showZonePropertiesColumn
        }) ;

    },

    ui: _.extend( {}, BaseRowView.prototype.ui, {
        zonePropertiesOpenerBtn:    '.fr-hit-more-btn',
        revertShapePositionBtn:     '.fr-revert-shape-position'
    }),

    // would delegation make more efficient at collection level make more efficient ?
    events:  _.extend( {}, BaseRowView.prototype.events, {

        'click @ui.revertShapePositionBtn':     'onRevertShapePosition',
        'click @ui.zonePropertiesOpenerBtn':    'toggleZonePropertiesDialog'
    }),


    /**
     * Create child view onRender, not onBeforeShow due to bug in this version of Marionette
     * ( see below notes )
     * this is also taking considerable time when looking at performance in Chrome tools/
     * ( Base only calls showHitCountView currently )
     */
    onRender: function() {

        if ( this.model.get('isApplied') ) {
            this.$el.addClass( 'isApplied' );
        }

        if ( this.model.get('isCollapsed') ) {
            this.$el.addClass( 'hide' );
        }

        this._createHitPreviewView();

        this.toggleShapeIsSelected();

    },

    /*
     *  Bug: onBeforeShow not called on children on children of composite/collection view
     *  https://github.com/marionettejs/backbone.marionette/issues/2428
     * TODO: -- we should upgrade anyway
     * onShow would work but in this version but currently unecessary
     * here: onRender show work for the hitPreview view ( won't yet be in DOM ) and dropdown view is done
     * on demand for higher performance
    onBeforeShow: function() {
        this._createHitPreviewView();
    },
    */
    _createHitPreviewView: function() {

        this.previewCellRegion.show( new HitPreviewView({
            model: this.model,
            channel: this.channel
        }));

    },

    /**
     * Create zone dialog on the fly for performance.
     * We could have a lot of hit views, don't create these unless necessary on demand.
     * Now it's actually a create from the initial button click event -- then the plugin takes over.
     */
    toggleZonePropertiesDialog: function(e) {

        // Don't allow to propagate -- there's click event handlers set by the plugin once established.
        // With current design of the plugin, this will not get called again ('click', stopImmediatePropagation).

        // So never need to call destroy -- also not really necessary to destroy once it's been created.
        // If there's ever a reason to do so or another use case, we can change the code
        // ** Update: there now is one: to be more consistent with the redaction properties dialog. **
        // - do this when combine dialog views
        // - may want a subview region show each time
        e.stopPropagation();

        var hitShape = this.model.get('shape');

        if ( !this.zonePropertiesDropdown ) {

            // Hack is now to create the view, append it to the DOM, and then call the dropdown
            // plugin on the opener with it's content set the the view DOM element

            var ShapePropertiesView = ShapePropertiesViewFactory( hitShape.parentNote, 'shape' );

            var vChannel = this.channel.request('vChannel');

            this.zonePropertiesDropdown = new ShapePropertiesView({
                shape: hitShape,
                channel: this.channel
            });

            // Note: would like to position relatively inside a container and not move on scroll,
            // but then dropdown would be positioned 'inside' the side container.
            // Area for optimization -wr::
            vChannel.request('getWrapper').append(
                this.zonePropertiesDropdown.render().el
            );

            // Mimic a show event for it to render as we're calling calling from a region in the view
            this.zonePropertiesDropdown.triggerMethod('beforeShow');

            // Note: custom open event wasn't working -- just use a click, which is working
            this.ui.zonePropertiesOpenerBtn.dropDown({

                content: this.zonePropertiesDropdown.$el,
                //openEvent: 'dd-open',
                isNotMenu: true, // don't capture click events on the dropdown (here view) -- also requires to prevent default click on inner view

                onBeforeOpen: function() {
                    vChannel.trigger( 'findAndRedact:openHitShapeDialog', hitShape );
                },
                // Proxy the onBeforeClose event from the dropdown plugin to the view -- (hack)
                onBeforeClose: _.bind(function() {

                    this.zonePropertiesDropdown.triggerMethod('dialogClose');

                    // this.ui.zonePropertiesOpenerBtn.destroy(); -- problem: this removes the opener
                    // would really want to print the whole thing s...
                    // when reopened, then most used reason codes would be placed atop

                }, this)


            }).trigger('click');

        }


    },

    forceCloseDialog: function() {

        if ( this.zonePropertiesDropdown ) {
            this.ui.zonePropertiesOpenerBtn.getDDEl().trigger('close');
        }

    },

    mouseEnter: function() {
        this.model.setIsMouseOverRowView( true );
    },

    mouseLeave: function() {
        this.model.setIsMouseOverRowView( false );
    },

    updateIsApplied: function() {

        var isApplied = this.model.get('isApplied');
        this.ui.selectHitCb[0].checked = isApplied;
        this.$el.toggleClass( 'isApplied', isApplied );

    },


    updateIsCollapsed: function( ) {
        this.$el.toggleClass( 'hide', this.model.get('isCollapsed') );
    },

    onRevertShapePosition: function() {
        this.channel.trigger( 'findAndRedact:revertShapePosition', this.model );
    },

    // TODO: scroll but we don't know the scroller yet
    toggleCanvasShapeHovered: function( hit, isMouseOverCanvasShape ) {
        this.$el.toggleClass( 'isMouseOverCanvasShape', isMouseOverCanvasShape );
    },

    toggleShapeIsSelected: function() {

        this.$el.toggleClass( 'isShapeSelected', this.model.get('shape').uiModel.get('isSelected') );

    },

    toggleShapeIsDirty: function( shapeUiModel, isDirty ) {
        this.ui.revertShapePositionBtn.toggleClass( 'hide', !isDirty );
    },

    destroy: function() {

        this.stopListening();

        this.zonePropertiesDropdown && this.zonePropertiesDropdown.destroy();

        BaseRowView.prototype.destroy.apply( this, arguments );


    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/hitRow/view.js
 ** module id = 617
 ** module chunks = 0
 **/